// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3GIMW","label":"Completed_label__GUyBR"};